import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdEdit } from "react-icons/md";
import CreateDesignations from "./addDesignations";
import MapDesignationsAndPackage from "./packagesAndDesignationsMapping";
import "./Spinner.css";
import "./Loader.css";
import UploadDesignationsCsvFile from "./designationCsvUpload";
import DesinationCsvFormat from "./designationCsvFormat";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import { RxCross2 } from "react-icons/rx";
import { FaPlusCircle } from "react-icons/fa";
import AddAgesPopup from "./addAgesPopup";
import "./hm-theme.css";

function Designations({ selectedOrgcode }) {
  const [packageDesignationAge, setPackageDesignationAge] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isMapDesignationAndPackage, setIsMapDesignationAndPackage] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [isCsvUplaodModalOpen, setIsCsvUplaodModalOpen] = useState(false);
  const [company, setCompany] = useState(null);
  const [selectedDes, setSelectedDes] = useState(null);
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [selectedGender, setSelectedGender] = useState(null);

  const token = JSON.parse(localStorage.getItem("data"))?.token;

  const getData = async () => {
    setLoader(true);
    try {
      const companyRes = await axios.get(
        `/api/companydetails/companycode=${selectedOrgcode}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const companyData = companyRes.data;
      if (!companyData || !companyData.id) {
        throw new Error("Company data not found or invalid.");
      }

      setCompany(companyData);

      const payload = { companyId: companyData.id };

      if (
        companyData.restrictedPkgByDesignation === false &&
        companyData.packageByAge === false
      ) {
        const designationRes = await axios.get(
          `/api/designation/companyId=${companyData.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setPackageDesignationAge(designationRes.data);
      } else {
        const packageRes = await axios.post(
          `/api/packageDesignationAgeMapping`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setPackageDesignationAge(packageRes.data);
      }

      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      handleError(error);
    }
  };

  useEffect(() => {
    if (selectedOrgcode) {
      getData();
    }
  }, [selectedOrgcode]);

  const navigate = useNavigate();
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleCreateCompany = () => {
    setSelectedDesignation(null);
    setIsModalOpen(true);
  };

  const handleEditDesignation = (designation) => {
    setSelectedDesignation(designation);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleOpenMapPopup = (designationId) => {
    setSelectedDesignation(designationId);
    setIsMapDesignationAndPackage(true);
  };

  const handleCloseMapPopup = () => {
    setSelectedDesignation(null);
    setIsMapDesignationAndPackage(false);
    getData();
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const handleShowImageModal = () => setShowImageModal(true);
  const handleCloseImageModal = () => setShowImageModal(false);

  const [showAgeModal, setShowAgeModal] = useState(false);
  const handleShowAgeModal = (designation, pkg, gender) => {
    setSelectedDes(designation);
    setSelectedPkg(pkg);
    setSelectedGender(gender);
    setShowAgeModal(true);
  };

  const closeAgeModal = () => {
    setSelectedDes(null);
    setSelectedPkg(null);
    setSelectedGender(null);
    setShowAgeModal(false);
    getData();
  };

  const uploadCsv = () => {
    setIsCsvUplaodModalOpen(true);
  };

  const closeUploadModal = () => {
    setIsCsvUplaodModalOpen(false);
    getData();
  };

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const handleDeleteAge = async (mappingId, age) => {
    if (window.confirm(`Delete age ${age}?`)) {
      const payload = { id: mappingId };
      try {
        const response = await axios.delete(`/api/packagedesignationmapping`, {
          headers: { Authorization: `Bearer ${token}` },
          data: payload,
        });

        if (response.status === 200) {
          toast.success("Age Deleted successfully");
          getData();
        }
      } catch (error) {
        handleError(error);
      }
    }
  };

  return (
    <div>
      {loader && <div className="loading"></div>}

      <div className="hm-card">
        {/* Card Header */}
        <div className="hm-card-header">
          <h3 className="hm-card-title">
            <i className="material-icons">badge</i>
            Designations & Packages
          </h3>
          <div className="d-flex align-items-center gap-2">
            <button className="btn btn-outline-primary rounded-pill px-3" onClick={handleShowImageModal}>
              View Format
            </button>
            <button className="btn btn-outline-secondary rounded-pill px-3" onClick={uploadCsv}>
              Upload CSV
            </button>
            <button className="btn-hm-primary" onClick={handleCreateCompany}>
              Add Designation
            </button>
          </div>
        </div>

        {/* Card Body & Table */}
        <div className="hm-card-body p-0">
          {company?.restrictedPkgByDesignation === false && company?.packageByAge === false ? (
            <div style={{ overflowX: "auto" }}>
              <table className="hm-table">
                <thead>
                  <tr>
                    <th>Designation</th>
                    <th style={{ width: "120px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {packageDesignationAge.length === 0 ? (
                    <tr>
                      <td colSpan="2">
                        <div className="hm-empty-state">
                          <i className="material-icons">assignment_late</i>
                          <p>No Designations Found</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    packageDesignationAge.map((designation) => (
                      <tr key={designation.designationId}>
                        <td className="fw-semibold">{designation.designation}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm rounded-circle p-1 d-inline-flex align-items-center justify-content-center"
                            style={{ width: "32px", height: "32px" }}
                            title="Edit Designation"
                            onClick={() => handleEditDesignation(designation.designationId)}
                          >
                            <MdEdit size={16} />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="hm-table">
                <thead>
                  <tr>
                    <th>Designation</th>
                    <th>Package Name</th>
                    <th>Gender</th>
                    {company?.packageByAge === true && <th>Age</th>}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {packageDesignationAge.length === 0 ? (
                    <tr>
                      <td colSpan={company?.packageByAge === true ? 5 : 4}>
                        <div className="hm-empty-state">
                          <i className="material-icons">assignment_late</i>
                          <p>No Designations Found</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    packageDesignationAge.map((designation) => {
                      if (designation.packageDesignationMapping.length === 0) {
                        return (
                          <tr key={designation.designationId}>
                            <td className="fw-semibold">{designation.designation}</td>
                            <td colSpan={company?.packageByAge === true ? 3 : 2} className="text-muted small">
                              No Packages Linked
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm rounded-pill px-3"
                                  onClick={() => handleOpenMapPopup(designation.designationId)}
                                >
                                  Link Package
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm rounded-circle p-1 d-inline-flex align-items-center justify-content-center"
                                  style={{ width: "32px", height: "32px" }}
                                  title="Edit Designation"
                                  onClick={() => handleEditDesignation(designation.designationId)}
                                >
                                  <MdEdit size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      }

                      const groupedByPackage = Object.values(
                        designation.packageDesignationMapping.reduce((acc, curr) => {
                          const key = curr.packageid;
                          if (!acc[key]) {
                            acc[key] = {
                              pac: curr.pac,
                              packageid: curr.packageid,
                              genderGroups: {},
                            };
                          }

                          if (!acc[key].genderGroups[curr.gender]) {
                            acc[key].genderGroups[curr.gender] = new Set();
                          }
                          if (curr.age) {
                            acc[key].genderGroups[curr.gender].add(curr.age);
                          }

                          return acc;
                        }, {})
                      );

                      return groupedByPackage.flatMap((pkg, pkgIndex) => {
                        const genderEntries = Object.entries(pkg.genderGroups);

                        return genderEntries.map(([gender, agesSet], idx) => {
                          return (
                            <tr key={`${designation.designationId}-${pkg.packageid}-${gender}`}>
                              {pkgIndex === 0 && idx === 0 && (
                                <td
                                  className="fw-bold text-dark align-middle"
                                  rowSpan={groupedByPackage.reduce((sum, p) => sum + Object.keys(p.genderGroups).length, 0)}
                                >
                                  {designation.designation}
                                </td>
                              )}

                              {idx === 0 && (
                                <td rowSpan={genderEntries.length} className="align-middle">
                                  <div className="d-flex align-items-center gap-2">
                                    <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-2 py-1 rounded-pill small fw-semibold">
                                      {pkg.pac?.packagename}
                                    </span>
                                    <FiInfo
                                      onClick={() => openTestsModal(pkg.packageid)}
                                      className="text-primary cursor-pointer"
                                      style={{ cursor: 'pointer', fontSize: '15px' }}
                                      title="View Tests"
                                    />
                                  </div>
                                </td>
                              )}

                              <td className="align-middle">
                                <span className={
                                  gender?.toLowerCase() === "female" ? "hm-badge hm-badge-info" :
                                  gender?.toLowerCase() === "male" ? "hm-badge hm-badge-primary" :
                                  "hm-badge hm-badge-warning"
                                }>
                                  {gender}
                                </span>
                              </td>

                              {company?.packageByAge === true && (
                                <td className="align-middle">
                                  <div className="d-flex align-items-center justify-content-between gap-2">
                                    <div className="d-flex flex-wrap gap-1 align-items-center">
                                      {Array.from(agesSet)
                                        .sort((a, b) => a - b)
                                        .map((age) => (
                                          <span key={age} className="badge bg-light text-dark border px-2 py-1 rounded-pill small d-inline-flex align-items-center gap-1">
                                            {age}
                                            <RxCross2
                                              style={{ color: '#dc2626', cursor: 'pointer' }}
                                              title="Delete Age"
                                              onClick={() => {
                                                const match = designation.packageDesignationMapping.find(
                                                  m => m.packageid === pkg.packageid && m.gender === gender && m.age === age
                                                );
                                                if (match) handleDeleteAge(match.id, age);
                                              }}
                                            />
                                          </span>
                                        ))}
                                    </div>

                                    <FaPlusCircle
                                      title="Add Age"
                                      style={{ color: '#059669', cursor: 'pointer', fontSize: '16px', flexShrink: 0 }}
                                      onClick={() => {
                                        handleShowAgeModal({
                                          designation,
                                          pkg,
                                          gender,
                                        });
                                      }}
                                    />
                                  </div>
                                </td>
                              )}

                              {pkgIndex === 0 && idx === 0 && (
                                <td
                                  className="align-middle"
                                  rowSpan={groupedByPackage.reduce((sum, p) => sum + Object.keys(p.genderGroups).length, 0)}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary btn-sm rounded-pill px-3"
                                      onClick={() => handleOpenMapPopup(designation.designationId)}
                                    >
                                      Link Package
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm rounded-circle p-1 d-inline-flex align-items-center justify-content-center"
                                      style={{ width: "32px", height: "32px" }}
                                      title="Edit Designation"
                                      onClick={() => handleEditDesignation(designation.designationId)}
                                    >
                                      <MdEdit size={16} />
                                    </button>
                                  </div>
                                </td>
                              )}
                            </tr>
                          );
                        });
                      });

                    })
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {isModalOpen && (
        <CreateDesignations
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          companyId={company?.id}
          companycode={company?.companycode}
          designationId={selectedDesignation}
        />
      )}

      {isCsvUplaodModalOpen && (
        <UploadDesignationsCsvFile
          isOpen={isCsvUplaodModalOpen}
          onRequestClose={closeUploadModal}
          companyId={company?.id}
          companycode={company?.companycode}
        />
      )}

      {showImageModal && (
        <DesinationCsvFormat isOpen={showImageModal} onRequestClose={handleCloseImageModal} />
      )}

      {isMapDesignationAndPackage && (
        <MapDesignationsAndPackage
          isOpen={isMapDesignationAndPackage}
          onRequestClose={handleCloseMapPopup}
          designationId={selectedDesignation}
          companyId={company?.id}
          companycode={company?.companycode}
        />
      )}

      {isTestsModalOpen && (
        <TestForPackage
          isOpen={isTestsModalOpen}
          onRequestClose={closeTestsModal}
          packageId={selectedPackage}
        />
      )}

      {showAgeModal && (
        <AddAgesPopup
          isOpen={showAgeModal}
          onRequestClose={closeAgeModal}
          des={selectedDes}
          pkg={selectedPkg}
          gender={selectedGender}
        />
      )}
    </div>
  );
}

export default Designations;

